export function mapPublicTestimonialsPayload(data) {
  if (!data) {
    return { pricingItems: [], signupItems: [] };
  }

  const mapItem = (item) => ({
    id: item.id,
    name: item.name,
    company: item.company,
    quote: item.quote,
    initials: item.initials,
    rating: item.rating ?? 5,
  });

  const pricingItems = Array.isArray(data.pricing) ? data.pricing.map(mapItem) : [];
  const signupItems = Array.isArray(data.signup) ? data.signup.map(mapItem) : [];

  return { pricingItems, signupItems };
}
